import { createCustomEnum } from "./customEnum";

const TerminalConfigurationOption = createCustomEnum({
	NewPurchase: {
		name: "new_purchase",
		value: 0,
		displayName: "New Purchase",
	},
	NewLease: {
		name: "new_lease",
		value: 1,
		displayName: "New Lease",
	},
	FileBuildOnly: {
		name: "file_build_only",
		value: 2,
		displayName: "File Build Only",
	},
	NewRental: {
		name: "new_rental",
		value: 3,
		displayName: "New Rental",
	},
});

export default TerminalConfigurationOption;
